import { LinkModel } from '@/types';
import React from 'react';
import HeadingTag from '../general/HeadingTag';
import classNames from 'classnames';
import Link from '../general/Link';
import { useTranslations } from 'next-intl';
import ArrowRightLight from '@/assets/arrowRightLight.svg';

export type ReportHeadingModel = {
  heading: string;
  headingTag?: string;
  description?: string;
  link?: LinkModel;
};

interface ReportCarouselHeadingModel {
  heading?: ReportHeadingModel;
  viewMoreLink?: LinkModel;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
  hideArrows?: boolean;
  hideViewMore?: boolean;
  className?: string;
  onNextClick?: () => void;
  onPrevClick?: () => void;
}

const ReportCarouselHeading = (data: ReportCarouselHeadingModel) => {
  const { heading, hideViewMore, hideArrows, prevDisabled, nextDisabled, onNextClick, onPrevClick, className } = data;
  const t = useTranslations();

  if (!heading?.heading && (!heading?.link || hideViewMore) && !heading?.description && hideArrows) return null;

  return (
    <div
      className={classNames(
        'align-center flex flex-wrap justify-between py-8 sm:pb-10 lg:pt-13 lg:pb-10 print:hidden',
        !heading?.link && 'items-center',
        className,
      )}
    >
      {(heading?.heading || (heading?.link && !hideViewMore)) && (
        <>
          {heading.heading ? (
            <HeadingTag
              animate={false}
              tag={heading.headingTag}
              heading={heading.heading}
              className="color-from-bg w-7/12 pb-3 sm:w-9/12 md:pb-5"
            />
          ) : (
            <div />
          )}

          {heading.link && !hideViewMore && (
            <div className="flex w-5/12 justify-end pt-2 pr-3 sm:w-3/12">
              <Link link={heading.link} className="btn secondary btn-from-bg h-fit whitespace-nowrap">
                {t('general.$viewMore')}
              </Link>
            </div>
          )}
        </>
      )}

      {!(heading?.heading || (heading?.link && !hideViewMore)) && <div className="w-9/12" />}

      {(heading?.description || !hideArrows) && (
        <>
          {heading?.description ? (
            <div className="body-1 color-from-bg sm:w-9/12 md:pt-[3px]">{heading.description}</div>
          ) : (
            <div className="w-20" />
          )}
          {!hideArrows && (
            <div className="hidden h-[28px] flex-row flex-nowrap items-center gap-4 lg:mr-0.5 lg:flex lg:pr-5">
              <button
                onClick={onPrevClick}
                disabled={prevDisabled}
                className={classNames(
                  'fill-from-bg transition-all disabled:opacity-20',
                  !prevDisabled && 'cursor-pointer opacity-60 hover:opacity-100',
                )}
              >
                <ArrowRightLight className="h-9 w-9 rotate-180" />
              </button>
              <button
                onClick={onNextClick}
                disabled={nextDisabled}
                className={classNames(
                  'fill-from-bg transition-all disabled:opacity-20',
                  !nextDisabled && 'cursor-pointer opacity-60 hover:opacity-100',
                )}
              >
                <ArrowRightLight className="h-9 w-9" />
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ReportCarouselHeading;
